// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"PassengerSeat__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AirlineSeatSelection/PassengerSeat.scss
 ** module id = 876
 ** module chunks = 1
 **/